import styled from 'styled-components'
import { Container } from '../Container'

const StyledStandardPageMain = styled.main`
  margin-bottom: 48px;
  a {
    scroll-behavior: smooth;
    scroll-margin-top: 140px;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  blockquote,
  ul,
  ol,
  p {
    max-width: 684px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 0;
    padding-right: 0;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: ${(props) => props.theme.v2.font.nantes};
  }
  h6 {
    font-size: ${(props) => props.theme.v2.typography.body.xs.fontSize};
    line-height: ${(props) => props.theme.v2.typography.body.xs.lineHeight};
  }
  p {
    font-size: ${(props) => props.theme.v2.typography.body.xs.fontSize};
    line-height: ${(props) => props.theme.v2.typography.body.xs.lineHeight};
    font-family: ${(props) => props.theme.v2.font.lotaGrotesqueLight};
    word-break: break-word;
  }
  ul,
  ol {
    padding-left: 32px;
    margin-top: 12px;
    margin-bottom: 12px;
  }

  blockquote {
    position: relative;
    padding-left: 52px;
    margin-top: 24px;
    margin-bottom: 24px;
    p {
      font-style: italic;
      font-size: ${(props) => props.theme.v2.typography.body.l.fontSize};
      line-height: ${(props) => props.theme.v2.typography.body.l.lineHeight};
    }
    &:before {
      content: '';
      position: absolute;
      width: 2px;
      height: 100%;
      top: 0;
      left: 24px;
      border-radius: 2px;
      background-color: ${(props) => props.theme.v2.interactive.bright};
    }
    footer {
      font-size: ${(props) => props.theme.v2.typography.body.m.fontSize};
      line-height: ${(props) => props.theme.v2.typography.body.m.lineHeight};
      &:before {
        content: '- ';
      }
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints.mobile}) {
      p {
        font-size: ${(props) => props.theme.v2.typography.body.s.fontSize};
        line-height: ${(props) => props.theme.v2.typography.body.s.lineHeight};
      }
      footer {
        font-size: ${(props) => props.theme.v2.typography.body.xs.fontSize};
        line-height: ${(props) => props.theme.v2.typography.body.xs.lineHeight};
      }
    }
  }
`

export const StandardPageMain = ({ children }) => {
  return (
    <StyledStandardPageMain id="main-content">
      <Container $size="narrow">{children}</Container>
    </StyledStandardPageMain>
  )
}
